import { z } from "zod";

export const TextChatSchema = z.object({
  Id: z.number().optional(),
  EventId: z.string().uuid().optional().nullable(),
  
  Name: z.string().optional().nullable(),
  AccessCode: z.string().optional().nullable(),
  Link: z.string().optional().nullable(),
  ReplyAllowed: z.boolean().default(false),
  Closed: z.boolean().default(false),
  ShowMessages: z.boolean().default(false),
  Alone: z.boolean().default(false),
  IncognitoAllowed: z.boolean().default(false),
  SearchAllowed: z.boolean().default(false),
  UploadAllowed: z.boolean().default(false),
  CloseAllowed: z.boolean().default(false),
  FieldMediaRequired: z.boolean().default(false),
  UserLimit: z.number().optional().nullable(),
  tom: z.string().optional().nullable(),
});


export type TextChatInfoSchema = {
  Id?:  number;
  EventId?: string | null;
  Name?: string | null;
  AccessCode?: string | null;
  Link?: string | null;
  ReplyAllowed?: boolean;
  Closed?: boolean;
  ShowMessages?: boolean;
  Alone?: boolean;
  IncognitoAllowed?: boolean;
  SearchAllowed?: boolean;
  UploadAllowed?: boolean;
  CloseAllowed?: boolean;
  FieldMediaRequired?: boolean;
  UserLimit?: number | null;
  tom?: string | null;
};


